import { Button, Card, CardContent } from 'alm-react-components';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";

import { useTranslation } from 'react-i18next';
import { constants } from '../../../assets/constants/constants';
import remindersIconImg from "../../../assets/images/svgicons/reminders-icon.svg";
import useAlmCorporateStatus from '../../../hooks/useAlmCorporateStatus';
import useDailyReminderHook from '../../../hooks/useDailyReminderHook';
import DailyReminderModal from '../../common/DailyReminderModal';
import PageLoader from '../../common/loader/PageLoader';
import withAlmToken from '../../common/withAlmToken';

function DailyReminders() {
  const navigate = useNavigate();
  const { dailyReminderData, loading } = useDailyReminderHook();
  const [fulltext, setFullText] = useState(false);
  const [dailyReminderText, setDailyReminderText] = useState("");
  const myRef = useRef<any>(dailyReminderData.map(() => React.createRef()));
  const location = useLocation();
  const from: any = location?.state?.from;

  const {t} = useTranslation();
  useAlmCorporateStatus();

  useEffect(() => {
    if (dailyReminderData) {
      myRef.current = myRef.current.slice(0, dailyReminderData.length);
    }
  }, [dailyReminderData]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  const backFromDailyReminder =()=>{
    if(from){
      navigate(from)
    }else{
      navigate(-1)
    }
  }
  return (
    <>
    <div>
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
        <div className="flex justify-between items-center pl-2">
          <Button
            onClick={() =>backFromDailyReminder()}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
          >
            <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
        </div>

        <h2 className="text-3xl font-barlowLight mt-6 pl-2"><span dangerouslySetInnerHTML={{ __html: (t('MyStance.newDailyReminders')) }}/></h2>
        <div className="flex -ml-4 lg:flex-row md:flex md:flex-row flex-wrap gap-y-6 mt-12">
          {dailyReminderData.length > 0 &&
            dailyReminderData?.map((res: any,index:number) => {
              return (
                    <div key={`daily-reminder-data-${index}`} className="min-w-0 shrink-0 grow-0 basis-full pl-4 landscape:2xl:basis-1/4 landscape:xl:basis-1/3 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                      <Card className="dark:card-gradient-gray dark:text-white dark:border-0 rounded-2xl pt-9 pb-8 h-full relative flex items-center justify-center">
                        <CardContent className="pt-4">
                        <div className=" justify-center flex mb-3">
                          <img src={remindersIconImg} alt={" "} className="logo text-sm w-[23px] h-[18px]" />
                        </div>
                        <p  className="text-base font-barlowLight text-primary leading-tight pb-6 text-center break-words select-none">
                    {res?.description?.length>constants.DAILYREMINDER_LIMIT? res?.description.slice(0,constants.DAILYREMINDER_LIMIT)+"...":res?.description}
                    </p>
                   {res?.description?.length > constants.DAILYREMINDER_LIMIT &&  
                   <p onClick={()=>{setDailyReminderText(res?.description.length > constants.DAILYREMINDER_LIMIT && (res?.description));setFullText(res?.description.length >constants.DAILYREMINDER_LIMIT ? true:false)}} className="text-center font-barlowLight cursor-pointer">
                    <a
                      dangerouslySetInnerHTML={{
                      __html: (t('Common.seeMore')),}}/></p>}
                          <div className="flex items-center justify-end absolute bottom-[10px] right-[10px]">
                            <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white">
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
              );
            })}
        </div>
        {dailyReminderData.length < 1 && (
          <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full text-2xl">
            <span dangerouslySetInnerHTML={{ __html: (t('MyStance.noDailyReminderFound')) }}/>
          </div>
        )}
      </div>
    </div>
    <DailyReminderModal fullText={fulltext} setFullText={setFullText} text={dailyReminderText}/>
    </>
  );
}

export default withAlmToken(DailyReminders);
